import React from 'react';
import { GetEditionParams } from '../../APIModels/getEditionParams';
import EditionService from '../../Services/editionService';
import { Container, Row, Col } from 'reactstrap';
import {Tooltip, Icon, Breadcrumb, Input, Button, Steps, Badge, Popover, Avatar, Card} from 'antd';
import { Article } from '../../Models/ModelIndex';
import ArticleService from '../../Services/articleService';
import moment from 'moment';
import queryString from 'query-string';
import { HandleArticleRender } from './HandleArticleRender';
import { HandleArticleFileRender } from './HandleArticleFileRender';
import { EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import ContentState from "draft-js/lib/ContentState";
import {Category} from "../../Models/Article";
import alertService from '../../Services/alertService';

const { Step } = Steps;

export class HandleArticles extends React.Component {
    constructor(props) {
        super(props)

        document.title = "Polar - Create article"

        let params = queryString.parse(this.props.location.search);
        let isFromEditionPage = false;
        if(params && params.editionId)
            isFromEditionPage = true;

        this.props.showUserBadge(false);
        this.state = {
            editionParam: new GetEditionParams(),
            editions: [],
            editionId: params.editionId,
            isFromEditionPage: isFromEditionPage,
            article: new Article(),
            articleSaved: false,
            activeMagazine: '',
            createdEdition: null,
            activeEdition: '',
            id: params.id,
            step: 0,
            editorState: EditorState.createEmpty(),
            categories: [],
            tagValue: ''
        }

        this.editionService = new EditionService(this.props.token);
        this.articleService = new ArticleService(this.props.token);

        this.fetchArticleById = this.fetchArticleById.bind(this);
        this.handleEdition = this.handleEdition.bind(this);
        this.handleCategory = this.handleCategory.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.createArticle = this.createArticle.bind(this);
        this.editArticle = this.editArticle.bind(this);
        this.changeStep = this.changeStep.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.onEditorStateChange = this.onEditorStateChange.bind(this);
        this.handleTagConfirm = this.handleTagConfirm.bind(this);
        this.handleTagChange = this.handleTagChange.bind(this);
        this.handleTagClose = this.handleTagClose.bind(this);
        this.handleOnline = this.handleOnline.bind(this);

    }

    componentDidMount() {
        if (this.state.id) {
            this.fetchArticleById(this.state.id);
        } else {
            this.fetchEditions();
        }
        this.getCategories();
    }


    getCategories(){
        this.articleService.getCategories()
        .then((response) => {
           if(response.data.ok){
               const data = response.data.data;
               this.setState({categories: data })
           }
        })
    }

    fetchArticleById(id) {
        this.props.loader(true)
        this.articleService.getArticle(id)
            .then((response) => {
                const blocksFromHtml = htmlToDraft(response.data.data.text);
                const { contentBlocks, entityMap } = blocksFromHtml;
                const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                const editorState = EditorState.createWithContent(contentState);
                
                this.setState({ article: response.data.data, editorState: editorState  }, (() => this.fetchEditions()))                 
                this.props.loader(false)
            }).catch((err) => {
                console.log(err);
                this.props.loader(false)
            })
    }

    //recupero tutte le edizioni
    //per la select
    //se sono nell'edit chiamo hanldeEdition per i campi Magazine, Date e la select
    fetchEditions() {
        this.props.loader(true)
        
        let param = this.state.editionParam;
        if(this.state.editionId){
            param.id = this.state.editionId;
            let article = this.state.article;
            article.editionId = this.state.editionId;
            this.setState({editionParam: param, article: article});
        }
        param.skipPagination = true;
            
        this.editionService.getEditionList(this.state.editionParam)
            .then((response) => {
                let data = response.data.data;
                //se sto filtrando per un id che non esisto torno alla create generica
                if(this.state.editionId && (data === null || data.length === 0)){
                    return window.open('archive/articles/create', '_self')
                }
                this.setState({ editions: data }, (() => {
                    if (this.state.article.editionId)
                        this.handleEdition(this.state.article.editionId)
                }));
                this.props.loader(false)
            })
            .catch((err) => {
                console.log(err);
                this.props.loader(false)
            });
    }

    //OnSelet per la select Edizioni
    //viene usato sopra nell'edit per configurare se stesso e i campi correlati: Magazine e Date
    handleEdition(value) {
        let article = this.state.article;
        article.editionId = value;

        let editions = this.state.editions;
        editions = editions.filter(e => e.id == value)[0];

        let magazine = editions.magazine.name;
        let activeEdition = editions.number;
        let createdEdition = moment(editions.competenceDateFrom);


        this.setState({ article: article, activeEdition: activeEdition, activeMagazine: magazine, createdEdition: createdEdition, editionSaved: false })
    }

    //OnSelect category
    handleCategory(value){
        let article = this.state.article;
        article.categoryId = +value;
        let categories = this.state.categories;
        article.category = categories.filter(e => e.id === +value)[0];

        this.setState({ article: article })
    }

    //handle per tutti gli input di testo
    handleInputChange({ target }) {
        const value = target.value;
        const name = target.name;
        this.setState(prevState => ({
            article: {
                ...prevState.article,
                [name]: value
            }
        }))
    }

    handleTagChange({target}){
        const value = target.value;
        this.setState({tagValue: value})
    }

    //submit - Save
    createArticle() {
        this.props.loader(true);
        this.articleService.addArticle(this.state.article)
            .then((response) => {
                if(response.data && response.data.ok){
                    alertService.setAlert('success', 'Article add');
                    var article = this.state.article;
                    article.id = response.data.data;
                    article.countPage = article.pageTo - article.pageFrom + 1;
                    this.props.loader(false);
                    this.setState({ article: article, step: 1 });
                }
                else{
                    this.props.loader(false);
                }
            })
            .catch((error) => console.log(error))
    }

    //submit - Edit
    editArticle() {
        this.props.loader(true);
        this.articleService.updateArticle(this.state.article)
            .then((respose) => {
                if(respose.data && respose.data.ok){
                    alertService.setAlert('success', 'Article update');
                    var article = this.state.article;
                    article.countPage = article.pageTo - article.pageFrom + 1;
                    this.props.loader(false);
                    this.setState({ article: article, step: 1 });
                }
                else{
                    this.props.loader(false);
                }
            })
            .catch((error) => console.log(error))
    }

    //clear
    handleClear(clear) {
        let article = this.state.article;
        if (clear === "editionId") {
            article.editionId = null;
            this.setState({ article: article, activeEdition: '' });
        }
        if (clear === "categoryId") {
            article.categoryId = null;
            article.category = new Category();
            this.setState({ article: article });
        }
    }

    goBack() {
        if(document.referrer) //exist prev url
            return window.history.back()
        else
            return window.open("/archive/articles", '_self');
    }

    //cambia step
    changeStep() {
        let value = this.state.step == 0 ? 1 : 0
        this.setState({ step: value })
    }

    onEditorStateChange (editorState) {
        let article = this.state.article;
        article.text = draftToHtml(convertToRaw(editorState.getCurrentContent()))
        this.setState({
            editorState,
            article
        });
    };

    handleTagConfirm() {
        let article = this.state.article;
        if(!article.tags){
            article.tags = [this.state.tagValue]
        }
        else{
            article.tags.push(this.state.tagValue)
        }

        this.setState(prevState => ({
            article: {
                ...prevState.article,
                tags: article.tags
            },
            tagValue: ''
        }))
    }

    handleTagClose(tag){
        let article = this.state.article;
        article.tags = article.tags.filter(t => t !== tag);
        this.setState(prevState => ({
            article: {
                ...prevState.article,
                tags: article.tags
            }
        }))
    }

    handleOnline({ target }) {
        this.setState(prevState => ({
            article: {
                ...prevState.article,
                isOnline: target.checked
            }
        }))
    }
    
    render() {

        let data = {
            editions: this.state.editions,
            article: this.state.article,
            articleSaved: this.state.articleSaved,
            activeMagazine: this.state.activeMagazine,
            activeEdition: this.state.activeEdition,
            createdEdition: this.state.createdEdition,
            editorState: this.state.editorState,
            categories: this.state.categories,
            tagValue: this.state.tagValue,
            isFromEditionPage: this.state.isFromEditionPage
        }

        let func = {
            editArticle: this.editArticle,
            createArticle: this.createArticle,
            handleEdition: this.handleEdition,
            handleCategory: this.handleCategory,
            handleInputChange: this.handleInputChange,
            handleTagConfirm: this.handleTagConfirm,
            handleTagClose: this.handleTagClose,
            handleTagChange: this.handleTagChange,
            handleClear: this.handleClear,
            onEditorStateChange: this.onEditorStateChange,
            handleOnline: this.handleOnline
        }

        return (
            <Container fluid={true} className="mb-5">
                <Row>
                    <Col sm="12" style={{display: 'inline-flex', height: '0', justifyContent: "end"}} className="mb-4">
                        <Breadcrumb className="bread" style={{left: 24}}>
                            <Breadcrumb.Item>
                                <Button className="fmk_button primary mr-2" style={{bottom: 3}} onClick={() => this.goBack()}>
                                    <Icon type="caret-left" />
                                </Button>
                                <strong className="h5 font-weight-bold" style={{color: 'black'}}>
                                    {this.state.id ? 'Edit' : 'Create'} Article
                                </strong>
                            </Breadcrumb.Item>
                        </Breadcrumb>
                        <div className="plusButtonCat">
                            <Badge>
                                <Popover placement="bottomRight" content={this.props.usercontent} trigger="click">
                                    <div style={{cursor: 'pointer'}}>
                                        <Avatar style={{backgroundColor: this.props.avatarColor, marginLeft: '5px'}}
                                                icon="user"/>
                                    </div>
                                </Popover>
                            </Badge>
                        </div>
                    </Col>

                    <Col sm="4" className="offset-4 mb-4">
                        <Card className="fmk_card p-4 mt-0" style={{borderRadius: "6px"}}>
                            <Steps current={this.state.step} onChange={(this.state.id) ? this.changeStep : null} className="p-0">
                                <Step title="Insert data" description="Data insert " icon={<Icon type="form"/>}/>
                                <Step title="Insert file" description="File insert" icon={<Icon type="file-add"/>}/>
                            </Steps>
                        </Card>
                    </Col>
                    {this.state.step == 0 ? (
                        <HandleArticleRender data={data} func={func}/>
                    ) : (
                        <HandleArticleFileRender article={this.state.article} loader={this.props.loader} user={this.props.token} />
                    )}
                   
                </Row>
            </Container>
        )
    }
}



// WEBPACK FOOTER //
// ./src/FileMaker/Articles/HandleArticles.js